import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Box, Image, Stack } from '@chakra-ui/core'

import messages from './messages'
import { MiniText } from '../ui/text'

const Footer = ({ intl: { formatMessage } }) => (
	<Stack as='footer' spacing={3} align='center'>
		<Box as='a' href={process.env.REACT_APP_QBETTER_SITE_PATH} target='_blank' rel='noopener'>
			<Image size={24} h='auto' src='/images/qbetter_logo.png' alt='Q-Better' ignoreFallback={true} />
		</Box>
		<MiniText color='gray.500' textDecoration='underline'>
			<a
				href={`mailto:${process.env.REACT_APP_FEEDBACK_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_FEEDBACK_EMAIL_SUBJECT}`}
				target='_blank'
				rel='noopener noreferrer'
			>
				{formatMessage(messages.feedback)}
			</a>
		</MiniText>
	</Stack>
)

Footer.propTypes = {
	intl: PropTypes.shape({ formatMessage: PropTypes.func.isRequired }).isRequired
}

export default injectIntl(Footer)
